import { MdOutlinePrecisionManufacturing } from "react-icons/md";
import { FaRegClipboard, FaWarehouse, FaTimes, FaDev, FaBug } from "react-icons/fa";
import { SiVodafone } from "react-icons/si";
import { VscClose,VscSymbolConstant } from "react-icons/vsc";
import { IoEllipsisVertical } from "react-icons/io5";

const _authIcon = (props) => {
    const {icon,className} = props;
    if (icon == "MdOutlinePrecisionManufacturing") return <MdOutlinePrecisionManufacturing className={className} />
    if (icon == "FaRegClipboard") return <FaRegClipboard className={className} />
    if (icon == "FaWarehouse") return <FaWarehouse className={className} />
    if (icon == "SiVodafone") return <SiVodafone className={className} />
    if (icon == "FaTimes") return <FaTimes className={className} />
    if (icon == "VscClose") return <VscClose className={className} />
    if (icon == "VscSymbolConstant") return <VscSymbolConstant className={className} />
    if (icon == "FaDev") return <FaDev className={className} />
    if (icon == "IoEllipsisVertical") return <IoEllipsisVertical className={className} />
    if (icon == "FaBug") return <FaBug className={className} />
    return null;
}

export default _authIcon;